import {Component, inject} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {TreeNode} from '../../../shared/primus-solr-tree-view/tree-node/tree-node.component';
import {ObjectTypes} from '../../../core/definitions/object-types';

/**
 * Dialog wrapper around the shared `app-primus-solr-tree-view`, letting an
 * operator browse the Place hierarchy and pick a node instead of relying on
 * the flat name search in `PlaceSelectComponent`. The tree reads the same
 * Solr index the `/places` admin page uses; the query bindings below are
 * copied from `AdminPlaceComponent` so both navigate Places identically.
 *
 * Closes with the picked `TreeNode` (`id` is the Place `artifact_id`), or
 * `undefined` on cancel or when only the synthetic root node is selected.
 */
@Component({
  selector: 'app-place-tree-dialog',
  templateUrl: './place-tree-dialog.component.html',
  styleUrls: ['./place-tree-dialog.component.scss'],
  standalone: false,
})
export class PlaceTreeDialogComponent {
  private readonly dialogRef: MatDialogRef<PlaceTreeDialogComponent> = inject(MatDialogRef);

  readonly query = `-valid:false AND object_type:${ObjectTypes.PLACE}`;
  readonly parentIdParentQueryPart =
    `{!parent which=object_type:${ObjectTypes.PLACE}}object_type:${ObjectTypes.MATERIALIZED_PATH_ITEM} AND `;
  readonly parentIdProp = 'materialized_paths.parent_id';
  readonly parentIdFlProp =
    `[child parentFilter=object_type:${ObjectTypes.PLACE} ` +
    `childFilter=object_type:${ObjectTypes.MATERIALIZED_PATH_ITEM} childFields=place.paths.level]`;
  readonly labelProp = 'place_name.name';

  selectedNode: TreeNode | null = null;

  onSelectionChanged(node: TreeNode | null): void {
    this.selectedNode = node;
  }

  confirm(): void {
    this.dialogRef.close(this.selectedNode || undefined);
  }

  cancel(): void {
    this.dialogRef.close(undefined);
  }
}
